import { deleteRequest, getRequest, postRequest } from '../util/api';
import { getConfigObject } from '../util/config';

const VERSION1 = '/api/v1/dashboards';

export const getFeatureCoursesView = async () => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await getRequest(
    `${DASHBOARD_API_URL}${VERSION1}/views/feature-courses`
  );
};

export const saveCourseFeature = async (
  courseId,
  featureName,
  enabled = true
) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await postRequest(
    `${DASHBOARD_API_URL}${VERSION1}/courses/${courseId}/features/${featureName}`,
    {
      enabled,
    }
  );
};

export const saveCourseFeatureBulk = async (featureCourses, enabled = true) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await postRequest(`${DASHBOARD_API_URL}${VERSION1}/features`, {
    featureCourses,
    enabled,
  });
};

export const removeCourseFeatureBulk = async (featureCourses) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  return await deleteRequest(`${DASHBOARD_API_URL}${VERSION1}/features`, {
    featureCourses,
  });
};

export const checkFeatureEnabled = (featureName) => async (courseId) => {
  const { DASHBOARD_API_URL } = getConfigObject();
  const featureUrl = `${DASHBOARD_API_URL}/api/v1/dashboards/courses/${courseId}/features/${featureName}`;
  try {
    const { enabled } = await getRequest(featureUrl);
    return enabled;
  } catch {
    return false;
  }
};

export const checkSearchAcrossSectionsEnabled = checkFeatureEnabled(
  'search_across_sections'
);
